import { Eleve } from 'types/eleves';
import _isEmpty from 'lodash-es/isEmpty';

export function isEleveNotInDecloisonnement(eleve: Eleve) {
  return _isEmpty(eleve.decloisonement);
}
